<template>
  <el-dialog
  :visible="dialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode" class="title" >{{ $t('products.newProduct') }}</span>
    <span v-if="isEditionMode" class="title" >{{ $t('products.editProduct') }}</span>
  </span>
  <el-form label-position="top"  :model="item" :rules="rules" ref="itemForm" >
    <el-tabs tab-position="top" v-model="tabs" type="border-card" style="max-width:1200px;margin:auto;">
      <el-tab-pane name="general" class="pl-10">
        <span slot="label"><i class="el-icon-s-tools"></i> {{$t('products.settings.tabs.configuration')}}</span>
        <el-row>
          <el-col >
              <el-form-item :label="$t('products.productType')" prop="type">
                <el-radio-group v-model="item.type" :disabled="!canEditProductInfos">
                  <el-radio-button label="0">{{$t('products.service')}}</el-radio-button>
                  <el-radio-button label="1">{{$t('products.goods')}}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item :label="$t('products.name')" prop="name">
              <el-input v-model="item.name" :disabled="!canEditProductInfos"></el-input>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item prop="sku">
              <span slot="label">
                {{$t('products.sku')}}
                <el-tooltip slot="label" class="item" effect="dark" :content="$t('products.skuInstruction')" placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input v-model="item.sku" :disabled="!canEditProductInfos"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
             <el-form-item :label="$t('products.externalId')">
              <el-input v-model="item.externalId" :disabled="!canEditProductInfos"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
           <el-form-item :label="$t('CMSProduct.product_type')" prop="type">
              <el-select
                  v-model="typeModel"
                  filterable
                  value-key="id"
                  @change="handleProductTypeChange"
                  clearable
                  :loading="productTypesLoading">
                  <el-option
                    v-for="item in productTypes"
                    :key="item.id"
                    :label="item.name[lang]"
                    :value="item">
                  </el-option>
                </el-select>
            </el-form-item>

          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
             <el-form-item :label="$t('CMSProduct.product_specific_type')" prop="specificType">
              <el-select
                  v-model="specificTypeModel"
                  filterable
                  :disabled="typeModel==null"
                  remote
                  clearable
                  value-key="id"
                  :loading="productTypesLoading">
                  <el-option
                    v-for="item in productSpecificTypesChoices"
                    :key="item.id"
                    :label="item.name[lang]"
                    :value="item">
                  </el-option>
                </el-select>
            </el-form-item> 
          </el-col>
        </el-row>
  
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('products.unit')" prop="unit">
              <el-select
                v-model="item.unit"
                filterable
                :disabled="item.type!=1 || !canEditProductInfos">
                <el-option
                  v-for="unit in units"
                  :key="unit.id"
                  :label="unit.label"
                  :value="unit.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('products.uvc')" prop="uvc">
                  <el-input-number v-model="item.uvc" :controls="false" :disabled="item.unit!=1 || item.type!=1 || !canEditProductInfos" style="width:100px;margin-left:"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" >
          <el-col :span="6">
            <el-form-item :label="$t('products.volume')" prop="volume">
              <el-input-number v-model="item.volume" :controls="false" :disabled="item.type!=1 || !canEditProductInfos" style="width:100px;margin-left:"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('products.format')" prop="format">
              <el-select
                v-model="item.format"
                filterable
                :disabled="item.type!=1 || !canEditProductInfos">
                <el-option
                  v-for="format in formats"
                  :key="format.id"
                  :label="format.label"
                  :value="format.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('products.panoramaCategory')" prop="panoramaCategory">
              <el-select 
                  v-model="item.panoramaCategory"
                  filterable
                  value-key="id"
                  @change="handlePanoramaCategoryChange"
                  :disabled="item.type!=1 || !canEditProductInfos">
                  <el-option
                    v-for="category in panoramaCategories"
                    :key="category.id"
                    :label="category.name[lang]"
                    :value="category">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
             <el-form-item :label="$t('products.panoramaSubCategory')" prop="panoramaSubCategory">
              <el-select 
                  v-model="item.panoramaSubCategory"
                  filterable
                  value-key="id"
                  :disabled="item.type!=1 || !canEditProductInfos || item.panoramaCategory==null">
                  <el-option
                    v-for="subCategory in panoramaSubCategoriesFiltered"
                    :key="subCategory.id"
                    :label="subCategory.name[lang]"
                    :value="subCategory">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('products.panoramaDesignation')">
              <el-input v-model="item.panoramaDesignation" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: AOC, IGT, DOC, DOCG'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
             <el-form-item :label="$t('products.panoramaAppellation')">
                <el-input v-model="item.panoramaAppellation" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: Margaux, Saint-Émilion'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('products.panoramaClassification')">
              <el-input v-model="item.panoramaClassification" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: Grand Cru Classé'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
             <el-form-item :label="$t('products.panoramaGrapes')">
                <el-input v-model="item.panoramaGrapes" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: cabernet-sauvignon, merlot'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('products.panoramaSweetness')">
              <el-select
                  v-model="item.panoramaSweetness"
                  filterable
                  value-key="id"
                  :disabled="item.type!=1 || !canEditProductInfos">
                  <el-option
                    v-for="sweetness in panoramaSweetness"
                    :key="sweetness.id"
                    :label="sweetness.name[lang]"
                    :value="sweetness">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
             <el-form-item :label="$t('products.panoramaSugarLevel')">
                <el-input v-model="item.panoramaSugarLevel" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: 4'"></el-input>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
             <el-form-item :label="$t('products.panoramaAlcoholLevel')">
                <el-input v-model="item.panoramaAlcoholLevel" @input="handleAlcoholLevelInput" :disabled="item.type!=1 || !canEditProductInfos" :placeholder="'Ex: 13.5'"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item :label="`${$t('products.shortDescription')} (max 255)`" prop="shortDescription">
          <el-input v-model="item.shortDescription" :maxlength="255" :disabled="!canEditProductInfos"></el-input>
        </el-form-item>
        <el-form-item :label="$t('products.description')">
          <quill-editor v-model="item.description" style="border:1px solid #EBEEF5;min-height:200px;"
            ref="noteEditor"
            :disabled="!canEditProductInfos"
            :options="editorOptions">
          </quill-editor>
        </el-form-item>
        <el-form-item :label="$t('products.tags')">
          <el-select
              v-if="item"
              v-model="item.tags"
              multiple
              filterable
              allow-create
              :placeholder="$t('products.tags')"
              :disabled="!canEditProductInfos"
              value-key="id">
              <el-option
                v-for="item in listTags"
                :key="item.id"
                :label="item.code"
                :value="item">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('products.webLink')">
          <el-input v-model="item.webLink" :disabled="!canEditProductInfos"></el-input>
        </el-form-item>
        <el-form-item :label="$t('products.supplier')">
          <el-select
            v-model="item.provider"
            filterable
            remote
            reserve-keyword
            clearable
            value-key="id"
            :disabled="!canEditProductInfos"
            :remote-method="providerRemoteMethod"
            :loading="providerLoading">
            <el-option
              v-for="item in providerOptions"
              :key="item.id"
              :label="getProviderName(item)"
              :value="item">
              <i v-if="item.company==null" class="mdi mdi-account-circle align-vertical-middle"></i>
              <i v-else class="mdi mdi-city align-vertical-middle"></i>
              <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{ getProviderName(item) }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('products.multipleAgency')" prop="agencyNumber" v-if="isMultiAgencyModuleActivated">
          <el-input v-model="item.agencyNumber" :disabled="!canEditProductInfos"></el-input>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane name="CMS" class="pl-10" :disabled="!canReadProductCMSInfos || !isCMSModuleActivated">
        <span slot="label"><i class="mdi mdi-earth"></i> {{$t('products.settings.tabs.CMS')}}</span>
        <CMSViewEditor
          @update="handleCmsUpdate"
          :showProductType="false"
          :id="item.id"
          :published="item.published"
          :publishedDate="item.publishedDate"
          :erpProduct="item"
          :cmsName="cmsName"
          :slug="item.slug"
          :contents="item.contents"
          :webSite="item.webSite"
          :category="item.category"
          :specificCategory="item.specificCategory"
          :image="item.image"
          :attributes="item.attributes"
          :origins="item.origins"
          :items="item.items"
          :cmsProvider="item.cmsProvider"
          :relatedProducts="item.relatedProducts"/>
      </el-tab-pane>
      <el-tab-pane :name="$t('products.characteristic')" class="pl-10">
        <span slot="label"><i class="el-icon-data-analysis"></i> {{$t('products.settings.tabs.characteristic')}}</span>
        <div v-if="item.type==1">
          <el-form-item :label="$t('products.dimension')">
                <el-input :placeholder="$t('products.length')" :disabled="!canEditProductInfos" v-model="item.length" style="width:100px;margin-right:5px;" ></el-input>
                <span>x</span>
                <el-input :placeholder="$t('products.width')"  :disabled="!canEditProductInfos" v-model="item.width" style="margin-left:5px;width:100px;margin-right:5px;"></el-input>
                <span>x</span>
                <el-input :placeholder="$t('products.height')"  :disabled="!canEditProductInfos" v-model="item.height" style="margin-left:5px;width:100px;"></el-input>
          </el-form-item>
          <el-form-item :label="$t('products.weight')">
                <el-input :placeholder="$t('products.weight')" :disabled="!canEditProductInfos" v-model="item.weight" style="width:100px;"></el-input>
          </el-form-item>
          <el-row :gutter="10">
            <el-col :span="12">
                <el-form-item :label="$t('products.upc')" prop="upc">
                  <span slot="label">
                    {{ $t('products.upc') }}
                    <el-tooltip slot="label" class="item" effect="dark" :content="$t('products.upcInsctruction')" placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </span>
                  <el-input placeholder="" v-model="item.upc" :disabled="!canEditProductInfos"></el-input>
                </el-form-item>
              </el-col>
            <el-col :span="12">
              <el-form-item  prop="ean">
                <span slot="label">
                  {{ $t('products.ean') }}
                  <el-tooltip slot="label" class="item" effect="dark" :content="$t('products.eanInsctruction')" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                <el-input placeholder="" v-model="item.ean" :disabled="!canEditProductInfos"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item  prop="mpn">
                  <span slot="label">
                    {{ $t('products.mpn') }}
                    <el-tooltip slot="label" class="item" effect="dark" :content="$t('products.mpnInsctruction')" placement="top-start">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </span>
                  <el-input placeholder="" v-model="item.mpn" :disabled="!canEditProductInfos"></el-input>
                </el-form-item>
              </el-col>
            <el-col :span="12">
              <el-form-item prop="isbn">
                <span slot="label">
                  {{ $t('products.isbn') }}
                  <el-tooltip slot="label" class="item" effect="dark" :content="$t('products.isbnInsctruction')" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
                <el-input placeholder="" v-model="item.isbn" :disabled="!canEditProductInfos"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      
      <!-- CONFIGURATION PAR COMPAGNIE -->
      <el-tab-pane v-for="portausCompany in item.portausCompanySettings" :key="portausCompany.id" class="pl-10" :disabled="!hasAccessToCompany(portausCompany.id)" >
        <span slot="label">
          <i class="mdi mdi-bank">
            <span v-if="portausCompanies.length === 1">{{$t('products.settings.tabs.financial')}}</span>
            <span v-else>{{getPortausCompanyName(portausCompany.id)}}</span>
          </i>
        </span>
        
        <el-col :span="12">
          <el-form-item>
            <el-checkbox v-model="portausCompany.taxable" :disabled="!canEditProductInfos">{{ $t('products.taxableQuestion') }}</el-checkbox>
            <!-- <el-checkbox v-model="portausCompany.returnable" :disabled="item.type==1 || !canEditProductInfos"> {{ $t('products.returnableQuestion') }}  <el-tooltip class="item" effect="dark" content="Activer cet option si ce produit peut être retourné." placement="top-start"><i class="el-icon-question"></i></el-tooltip></el-checkbox> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('products.activeProduct')" >
            <el-radio-group v-model="portausCompany.active" :disabled="!canEditProductInfos" @change="handleActive">
              <el-radio-button label="true">{{$t('products.active')}}</el-radio-button>
              <el-radio-button label="false">{{$t('products.inactive')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="portausCompany.reservationActive" :disabled="!canEditProductInfos">
              {{ $t('products.reservationActive') }}
              <el-tooltip class="item" effect="dark" :content="$t('products.reservationActiveTooltip')" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-form-item :label="$t('products.taxes')">
          <el-select
              :disabled="!portausCompany.taxable || !canEditProductInfos"
              v-model="portausCompany.taxes"
              multiple
              filterable
              value-key="id">
              <el-option
                v-for="item in gerPortausCompanyTaxes(portausCompany.id)"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
        </el-form-item>

        <!-- <h3>{{ $t('products.basicSetup')}}</h3> -->
          <el-row :gutter="20" class="pl-10">
              <h3>{{ $t('products.purchaseInformation') }}</h3>
              <el-col :span="12">
                <el-form-item :label="$t('products.costPrice')">
                  <el-input-number v-model="portausCompany.purchaseUnitPrice" :precision="2" :disabled="item.type != 1 || !canEditProductInfos" :step="0.1" :min="0"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('products.glAccount')">
                  <el-select v-model="portausCompany.purchaseAccount" placeholder="Select" :disabled="item.type != 1 || !canEditProductInfos" value-key="id">
                    <el-option
                      v-for="account in getGlAccountsByCompanyId[portausCompany.id]"
                      :key="account.id"
                      :label="gl_account_name(account)"
                      :value="account">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20" class="pl-10">
              <h3>{{  $t('products.salesInformation') }}</h3>
              
              
              <el-divider>Gestion des frais d'agences</el-divider>
              <el-col :span="12">
                <el-form-item >
                  <el-checkbox v-model="portausCompany.fixedRate" :disabled="!canEditProductInfos" @change="v => handleFixedFee(v, portausCompany)">Activer le frais d'agence fixe</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Frais d'agence" >
                  <el-input-number v-model="portausCompany.agencyFee" :precision="2" :step="1" :min="0" :disabled="!portausCompany.fixedRate || !canEditProductInfos"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item >
                  <el-checkbox v-model="portausCompany.variableRate" :disabled="!canEditProductInfos" @change="v => handleVariableRate(v, portausCompany)">{{$t('products.agencyRatePercentIndicator')}}</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('products.agencyRate')" >
                  <el-input-number v-model="portausCompany.itemRate" :precision="4" :step="0.1" :min="0" :max="1" :disabled="!portausCompany.variableRate || !canEditProductInfos"></el-input-number>
                </el-form-item>
                <el-form-item v-if="portausCompany.variableRate || portausCompany.fixedRate">
                  <el-checkbox v-model="configureRateByCustomerInd" :disabled="!canEditProductInfos" @change="v => handleConfigureRateByCustomerClass(v, portausCompany)">{{$t('products.configureRateByCustomerClasses')}}</el-checkbox>
                </el-form-item>
                
              </el-col>
              <el-col class="mb-10 bg-accent-lighter p-10" v-if="configureRateByCustomerInd && (portausCompany.variableRate === true || portausCompany.fixedRate === true)">
                <el-form-item :label="$t('common.selectCustomerClasse')">
                  <el-select v-model="selectedCustomerClass" value-key="id" @change="v => handleCustomerClassSelection(v, portausCompany)" style="max-width:400px;">
                    <el-option
                      v-for="item in customerClasses"
                      :key="item.id"
                      :label="item.code"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-table 
                  :data="portausCompany.agencyRateByClasses"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="customerClassId"
                    :label="$t('common.customerClass')">
                    <template slot-scope="scope" >
                      <span>{{ getCustomerClassName(scope.row.customerClassId) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="agencyRate"
                    :label="$t('common.rate')">
                    <template slot-scope="scope" >
                      <el-input-number v-model="scope.row.agencyRate" :precision="4" :step="0.1" :min="0" :max="1" :disabled="!canEditProductInfos"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="agencyRate"
                    :label="$t('common.fixedRate')">
                    <template slot-scope="scope" >
                      <el-input-number v-model="scope.row.agencyFee" :precision="2" :step="1" :min="0"  :disabled="!canEditProductInfos"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope" >
                      <el-button size="mini" circle type="danger" @click="removeCustomerClassPrice(scope.$index, portausCompany)"><i class="mdi mdi-delete fs-15"></i></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('products.salesPrice')">
                  <el-input-number v-model="portausCompany.sellingUnitPrice" :precision="2" :step="0.1" :min="0" :disabled="!canEditProductInfos"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('products.glAccount')">
                  <el-select v-model="portausCompany.salesAccount" placeholder="Select" value-key="id" :disabled="!canEditProductInfos" default-first-option>
                    <el-option
                      v-for="account in getGlSalesAccountsByCompanyId[portausCompany.id]"
                      :key="account.id"
                      :label="gl_account_name(account)"
                      :value="account">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              </el-row>
              <el-row>
              <el-divider>Gestion des commissions des représentants</el-divider>
              <h4></h4>
              <el-col :span="12">
                <el-form-item >
                  <el-checkbox v-model="portausCompany.salesCommission.fixedAmountInd" :disabled="!canEditProductInfos" @change="v => handleFixedCommissionAmount(v, portausCompany)">Activer une commission fixe</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Montant" >
                  <el-input-number v-model="portausCompany.salesCommission.fixedAmount" :precision="2" :step="1" :min="0" :disabled="portausCompany.salesCommission.fixedAmountInd === false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item >
                  <el-checkbox v-model="portausCompany.salesCommission.rateInd" :disabled="!canEditProductInfos" @change="v => handleFixedCommissionRate(v, portausCompany)">Activer une commission selon un taux</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Taux" >
                  <el-input-number v-model="portausCompany.salesCommission.rate" :precision="4" :step="0.1" :min="0" :max="1" :disabled="portausCompany.salesCommission.rateInd === false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col>
              <el-form-item >
                  <el-checkbox v-model="configureCommissionRateByCustomerInd" :disabled="!canEditProductInfos" @change="v => handleConfigureCommissionByCustomerClass(v, portausCompany)">Configurer les commissions par classe client</el-checkbox>
                </el-form-item>
                </el-col>
              <el-col class="mb-10 bg-accent-lighter p-10" v-if="configureCommissionRateByCustomerInd">
                <el-form-item :label="$t('common.selectCustomerClasse')">
                  <el-select v-model="selectedCommissionCustomerClass" value-key="id" @change="v => handleCommissionCustomerClassSelection(v, portausCompany)" style="max-width:400px;">
                    <el-option
                      v-for="item in customerClasses"
                      :key="item.id"
                      :label="item.code"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-table 
                  :data="portausCompany.salesCommission.agencyRateByClasses"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="customerClassId"
                    :label="$t('common.customerClass')">
                    <template slot-scope="scope" >
                      <span>{{ getCustomerClassName(scope.row.customerClassId) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="agencyRate"
                    :label="$t('common.rate')">
                    <template slot-scope="scope" >
                      <el-input-number v-model="scope.row.rate" :precision="4" :step="0.1" :min="0" :max="1" :disabled="!canEditProductInfos"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="agencyRate"
                    :label="$t('common.fixedRate')">
                    <template slot-scope="scope" >
                      <el-input-number v-model="scope.row.fixedAmount" :precision="2" :step="1" :min="0"  :disabled="!canEditProductInfos"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope" >
                      <el-button size="mini" circle type="danger" @click="removeCustomerClassCommission(scope.$index, portausCompany)"><i class="mdi mdi-delete fs-15"></i></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="20" class="pl-10">
              <h3>{{$t('products.commission')}}</h3>
              <el-col :span="12">
                <el-form-item :label="$t('products.marginRate')">
                  <el-input-number v-model="portausCompany.marginRate" :disabled="item.type!=1 || !canEditProductInfos" :precision="2" :step="0.05" :min="0" :max="1"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('products.glAccount')">
                  <el-select v-model="portausCompany.commissionAccount" placeholder="Select" :disabled="item.type!=1 || !canEditProductInfos" value-key="id">
                    <el-option
                      v-for="account in getGlAccountsByCompanyId[portausCompany.id]"
                      :key="account.id"
                      :label="gl_account_name(account)"
                      :value="account">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row :gutter="20" class="pl-10">
              <el-col :span="12">
                <h3>{{$t('products.consigneTitle')}}</h3>
                <el-form-item :label="$t('products.consigne')">
                  <SelectProduct 
                    :type="0"
                    :active="true"
                    :product="portausCompany.additionnalProductFee"
                    @selected=" p => handleSelectDepositProduct(p, portausCompany)"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          <el-divider />
          <div v-if="item.type === 1 && isMultipleInventorySystem === true">
            <h3>{{ $t('products.advancedSettings') }}</h3>
            <el-collapse accordion v-model="configurationInventoryTabs">
            
            <el-collapse-item  :name="inventorySetting.inventoryId" v-for="inventorySetting in portausCompany.inventorySettings" :key="inventorySetting.id">
              <template slot="title">
                {{inventorySetting.name}}
                <i v-if="inventorySetting.active" class="header-icon accent-text el-icon-success ml-5"></i>
                <i v-else class="header-icon el-icon-error ml-5"></i>
              </template>  
              <div class="bg-accent-lighter p-10"> 
              <el-row :gutter="20" class="pl-10">
                <el-col :span="12">
                  <el-form-item>
                    <el-radio-group v-model="inventorySetting.active" :disabled="!canEditProductInfos" @change="handleActive">
                      <el-radio-button :label="true">{{ $t('products.active') }}</el-radio-button>
                      <el-radio-button :label="false">{{ $t('products.inactive') }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col> 
              </el-row>
              <el-row :gutter="20" class="pl-10">
                <el-col :span="12">
                  <el-form-item :label="$t('products.unit')" prop="unit">
                    <el-select
                      v-model="inventorySetting.unit"
                      filterable
                      :disabled="item.type!=1 || !canEditProductInfos">
                      <el-option
                        v-for="unit in units"
                        :key="unit.id"
                        :label="unit.label"
                        :value="unit.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col> 
                <el-col :span="12">
                  <el-form-item :label="$t('products.uvc')" prop="uvc">
                    <el-input-number v-model="inventorySetting.uvc" :controls="false" :disabled="inventorySetting.unit!=1 || item.type!=1 || !canEditProductInfos" style="width:100px;margin-left:"></el-input-number>
                  </el-form-item>
                </el-col> 
              </el-row>
              <el-row :gutter="20" class="pl-10">
                  <h4>{{ $t('products.purchaseInformation') }}</h4>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.costPrice')">
                      <el-input-number v-model="inventorySetting.purchaseUnitPrice" :precision="2" :disabled="item.type != 1 || !canEditProductInfos" :step="0.1" :min="0"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.glAccount')">
                      <el-select v-model="inventorySetting.purchaseAccount" placeholder="Select" :disabled="item.type != 1 || !canEditProductInfos" value-key="id">
                        <el-option
                          v-for="account in getGlAccountsByCompanyId[portausCompany.id]"
                          :key="account.id"
                          :label="gl_account_name(account)"
                          :value="account">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="pl-10">
                  <h4>{{ $t('products.salesInformation') }}</h4>
                  <el-col :span="12">
                    <el-form-item >
                      <el-checkbox v-model="inventorySetting.variableRate" :disabled="!canEditProductInfos">{{$t('products.agencyRatePercentIndicator')}}</el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.agencyRate')" >
                      <el-input-number v-model="inventorySetting.itemRate" :precision="4" :step="0.1" :min="0" :max="1" :disabled="!inventorySetting.variableRate || !canEditProductInfos"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.salesPrice')">
                      <el-input-number v-model="inventorySetting.sellingUnitPrice" :precision="2" :step="0.1" :min="0" :disabled="!canEditProductInfos"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.glAccount')">
                      <el-select v-model="inventorySetting.salesAccount" placeholder="Select" value-key="id" :disabled="!canEditProductInfos">
                        <el-option
                          v-for="account in getGlSalesAccountsByCompanyId[portausCompany.id]"
                          :key="account.id"
                          :label="gl_account_name(account)"
                          :value="account">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="pl-10">
                  <h4>{{$t('products.commission')}}</h4>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.marginRate')">
                      <el-input-number v-model="inventorySetting.marginRate" :disabled="item.type!=1 || !canEditProductInfos" :precision="2" :step="0.05" :min="0" :max="1"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('products.glAccount')">
                      <el-select v-model="inventorySetting.commissionAccount" placeholder="Select" :disabled="item.type!=1 || !canEditProductInfos" value-key="id">
                        <el-option
                          v-for="account in getGlAccountsByCompanyId[portausCompany.id]"
                          :key="account.id"
                          :label="gl_account_name(account)"
                          :value="account">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" class="pl-10">
                  <el-col :span="12">
                    <h4>{{$t('products.consigneTitle')}}</h4>
                    <el-form-item :label="$t('products.consigne')">
                      <SelectProduct 
                        :type="0"
                        :active="true"
                        :product="inventorySetting.additionnalProductFee"
                        @selected=" p => handleSelectDepositProduct(p, inventorySetting)"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-collapse-item>
            
            </el-collapse>
          </div>
        </el-tab-pane>
    </el-tabs>
  </el-form>

  <span slot="footer" class="dialog-footer">
    <el-button @click="closeItemDialog">{{ $t('common.Cancel')}}</el-button>
    <el-button v-if="!isEditionMode" type="primary" @click="saveProduct">{{ $t('common.save') }}</el-button>
    <el-button v-if="isEditionMode" type="primary" @click="editItem">{{ $t('common.save') }}</el-button>
  </span>
</el-dialog>
</template>
<script>
import axios from "axios"

import SystemAPI from '@/services/API/system'
import productAPI from '@/services/API/product'
import CMSViewEditor from './cms-view-editor'
import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';
import SelectProduct from '@/components/product/select-product.vue'
import dayjs from 'dayjs';
import panoramaAPI from '@/services/API/panorama'
export default {
  name: 'ItemDialog',
	props: {
		dialogVisible : Boolean,
    itemIdToEdit : Number,
	},
  data() {
    // var validatePanoramaCategory = (rule, value, callback) => {
    //     if(this.item.type==1 && (value ==null || value == '')){
    //        this.$notify({
    // 						title: "Ajout d'un produit",
    // 						message: "Veuillez spécifier une catégorie dans l'onglet configuration.",
    // 						type: 'error'
    // 					});
    //       callback(new Error("Veuillez spécifier une catégorie."));
    //     }else{
    //       callback();
    //     }
    //   };
    //   var validatePanoramaSubCategory = (rule, value, callback) => {
    //     if(this.item.type==1 && (value ==null || value == '') && _.size(this.panoramaSubCategoriesFiltered) > 0){
    //       this.$notify({
    // 						title: "Ajout d'un produit",
    // 						message: "Veuillez spécifier une sous-catégorie dans l'onglet configuration.",
    // 						type: 'error'
    // 					});
    //       callback(new Error("Veuillez spécifier une sous-catégorie."));
    //     }else{
    //       callback();
    //     }
    //   };
    var validateUVC = (rule, value, callback) => {
        if ((value ==null || value==='') && this.item.unit==1) {
          callback(new Error("Veuillez renseigné le nombre d'unité par boîte"));
        } else {
          callback();
        }
      };
      var validateUnit = (rule, value, callback) => {
          if ((value ==null || value==='') && this.item.type==1) {
            callback(new Error("Veuillez renseigné l'unité désiré"));
          } else {
            callback();
          }
        };
      var validateSKU = (rule, value, callback) => {
          productAPI.validate(_.trim(this.actualSku), {sku:_.trim(value)})
            .then(()=>{
              callback();
            }).catch(err=>{
              if (_.get(err, 'response.status') === 409) {
                callback(new Error("Un sku existe déjà avec ce numéro. Veuillez renseigner un sku unique."));
              } else {
                this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard!');
                callback();
              }
            })
        };
      var validateFormat = (rule, value, callback) => {
        if(this.item.type==1 && (value ==null || value == '')){
          callback(new Error("Veuillez spécifier un format."));
        }else{
          callback();
        }
      };
      var validateShortDescription = (rule, value, callback) => {
        if (value != null && `${value}`.length > 255) {
          callback(new Error("La description courte doit contenir au maximum 255 caractères."));
        } else {
          callback();
        }
      };
    return {
      configurationTabs: ['0'],
      configurationInventoryTabs: [],
      tabs: 'general',
      actualSku : null,
      productTypesLoading: false,
      configureRateByCustomerInd: false,
      configureCommissionRateByCustomerInd: false,
      selectedCustomerClass : null,
      selectedCommissionCustomerClass : null,
      item : {
          id : null,
          externalId: null,
          type : 1,
          active : null,
          variableRate : false,
          fixedRate: false,
          commissionAccount : null,
          shortDescription : null,
          description : null,
          ean : null,
          provider : null,
          format : 1,
          height : null,
          isbn : null,
          length : null,
          marginRate: null,
          mpn : null,
          name : null,
          purchaseAccount : null,
          purchaseUnitPrice : null,
          quantities : [],
          reorderLevel : null,
          returnable : null,
          salesAccount : null,
          sellingUnitPrice :null,
          portausCompanySettings: [],
          sku : null,
          tags : [],
          taxable : true,
          taxes : [],
          unit :1,
          upc : null,
          uvc : '12',
          volume : '750',
          webLink : null,
          weight: null,
          width : null,
          itemRate : null,
          agencyRate : null,
          cmsName: null,
          slug: null,
          contents: [],
          webSite: null,
          category: null,
          specificCategory: null,
          attributes: [],
          origins: [],
          aliasName: null,
          items : [],
          image : null,
          cmsProvider: null,
          published: true,
          publishedDate: null,
          agencyNumber: null,
          relatedProducts: [],
          panoramaDesignation: null,
          panoramaAppellation: null,
          panoramaClassification: null,
          panoramaGrapes: null,
          panoramaCategory: null,
          panoramaSubCategory: null,
          panoramaSweetness: null,
          panoramaSugarLevel: null,
          panoramaAlcoholLevel: null,
      },
      panoramaCategories: [],
      panoramaSubCategories: [],
      panoramaSweetness: [],
      productTypes: [],
      listTags : [],
      units : [{id:1, label:"Boîte"},{id:2, label:"Unitaire"}],
      formats : [{id:1, label:"ml"},{id:2, label:"L"}],
      rules : {
        sku : [
  	  		 	{ required: true, message: 'Veuillez saisir un sku.', trigger: 'blur' },
            { validator : validateSKU, trigger: 'blur' }
  	  		],
  	  	name : [
  	  		 	{ required: true, message: 'Veuillez saisir un nom.', trigger: 'blur' }
  	  		],
        format : [
          { validator : validateFormat, trigger: 'blur' }
        ],
        unit : [
            { validator : validateUnit, trigger: 'blur' }
        ],
        uvc : [
           { validator : validateUVC, trigger: 'blur' }
        ],
        shortDescription: [
          { validator: validateShortDescription, trigger: 'blur' }
        ],
        // panoramaCategory : [
        //    { validator : validatePanoramaCategory, trigger: 'blur' }
        // ],
        // panoramaSubCategory : [
        //    { validator : validatePanoramaSubCategory, trigger: 'blur' }
        // ]
  	  },
      editorOptions: {
				theme: 'bubble',
        placeholder:"",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike']
					]
				}
			},
      fullScreenLoading : false,
      providerLoading : false,
      providerOptions : [],
      showProductType: true,
    };
  },components: {
    CMSViewEditor,
    SelectProduct
  },
	methods: {
    handlePanoramaCategoryChange () {
      this.item.panoramaSubCategory = null;
    },
    handleAlcoholLevelInput(value) {
      // Remplacer les virgules par des points et garder uniquement les chiffres et points
      this.item.panoramaAlcoholLevel = value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
    },
    handleFixedCommissionAmount (value, portausCompany) {
      if (value === true) {
        portausCompany.salesCommission.rateInd = false;
      } 
    },
    handleFixedCommissionRate(value, portausCompany) {
      if (value === true) {
        portausCompany.salesCommission.fixedAmountInd = false;
      } 
    },
    handleFixedFee (value, portausCompany) {
      if (value === false && _.size(portausCompany.agencyFeeByClasses) > 0) {
        this.$confirm(this.$i18n.t('products.confirmDeleteAgencyFeeByClasses'), this.$i18n.t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          portausCompany.agencyFeeByClasses = [];
        }).catch(() => {
          portausCompany.fixedRate = true;
        })
      }  else if (value === true) {
          portausCompany.variableRate = false;
        }
    },
    handleVariableRate (value, portausCompany) {
      if (value === false && _.size(portausCompany.agencyRateByClasses) > 0) {
        this.$confirm(this.$i18n.t('products.confirmDeleteAgencyRateByClasses'), this.$i18n.t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          portausCompany.agencyRateByClasses = [];
        }).catch(() => {
          portausCompany.variableRate = true;
        }) 
      } else if (value === true) {
          portausCompany.fixedRate = false;
        }
    },
    handleConfigureRateByCustomerClass (value, portausCompany) {
      if (value === false && _.size(portausCompany.agencyRateByClasses) > 0) {
        this.$confirm(this.$i18n.t('products.confirmDeleteAgencyRateByClasses'), this.$i18n.t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          portausCompany.agencyRateByClasses = [];
        }).catch(() => {
          portausCompany.variableRate = true;
        })
      } 
    },
    handleConfigureCommissionByCustomerClass (value, portausCompany) {
      if (value === false && _.size(_.get(portausCompany, 'salesCommission.agencyRateByClasses')) > 0) {
        this.$confirm(this.$i18n.t('products.confirmDeleteAgencyRateByClasses'), this.$i18n.t('warning'), {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          portausCompany.salesCommission.agencyRateByClasses = [];
        }).catch(() => {
          this.configureCommissionRateByCustomerInd = true;
        })
      } 
    },
    handleCommissionCustomerClassSelection (v, portausCompany) {
      this.selectedCustomerClass = null;
      if (_.get(portausCompany, 'salesCommission.agencyRateByClasses') == null) {
        _.set(portausCompany, 'salesCommission.agencyRateByClasses', []);
      }

      portausCompany.salesCommission.agencyRateByClasses.push({customerClassId: v, rate: null, fixedAmount: null});
    },

    handleCustomerClassSelection (v, portausCompany) {
      this.selectedCustomerClass = null;
      if (portausCompany.agencyRateByClasses == null) {
        portausCompany.agencyRateByClasses = [];
      }
      portausCompany.agencyRateByClasses.push({customerClassId: v, agencyRate: null, agencyFee: null});

    },
    getCustomerClassName (id) {
      return _.get(this.getCustomerClassById(id), 'code');
    },
    removeCustomerClassPrice (index, portausCompany) {
      portausCompany.agencyRateByClasses.splice(index, 1);
    },
    removeCustomerClassCommission (index, portausCompany) {
      portausCompany.salesCommission.agencyRateByClasses.splice(index, 1);
    },
    handleSelectDepositProduct (additionnalProductFee, item){
      if (additionnalProductFee == null || additionnalProductFee === '') {
        item.additionnalProductFee = null;
      } else {
        item.additionnalProductFee = additionnalProductFee;
      }
    },
    gerPortausCompanyTaxes (id) {
      const portausCompany = _.find(this.portausCompanies, pc => pc.id === id);
      return _.get(portausCompany, 'taxes');
    },
    getPortausCompanyName (id) {
      const portausCompany = _.find(this.portausCompanies, pc => pc.id === id);
      return _.get(portausCompany, 'name');
    },
    fetchProductTypes (){
      this.productTypesLoading = true;
      return cmsAPI.fetchProductTypes()
        .then(specificTypes=>{
          this.productTypes = specificTypes;
          this.productTypesLoading = false;

        })
    },
    handleActive(active) {
      if (active === 'false') {
        this.item.published = false;
      }
    },
    getProduct (id = null) {
      const productId = id != null ? id : this.itemIdToEdit;
      if (productId == null) return Promise.resolve();
      return productAPI.getProductDefinitionV2(productId, {});
    },
    handleProductTypeChange () {
      this.handleCmsUpdate({ specificCategory: null });
    },
    handleCmsUpdate (props) {
      _.forIn(props,  (value, key) => {
        if (key === 'image') {
         
          if (value == null) {
            this.$set(this.item, key, null);
          } else {
            this.$set(this.item, key, value);
          }
          
        } else if (key === 'category' || key === 'specificCategory' || key === 'published') {
          this.$set(this.item, key, value);
        } else {
          this.item[key] = value;
        }

      })
    },
    fetchTags(){
      return SystemAPI.getTags('PRODUCT',true)
        .then(tags=>{
          this.listTags = tags;
        })
    },
    getProviderName(provider){
      if(provider!=null && provider.usual_name!=null && provider.usual_name!=''){
        return provider.usual_name;
      }else if(provider!=null && provider.usualName!=null && provider.usualName!=''){
        return provider.usualName;
      }else if(provider!=null){
        return provider.name;
      }
    },
    providerRemoteMethod(query){
        var params = {};
        params.is_provider=true;
        params.searchTerms = query;
        params.active = true;
        return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/customers/", {params : params})
          .then(results=>{
            this.providerOptions = results.data.customers;
          })
    },
    addCurrentTagIfNotPresent(listTags, currentTags){
      _.forEach(currentTags, t=>{
        let tagFound = _.find(listTags, t2=>{return t2.code==t.code});
        if(tagFound==null){
          this.listTags.push(t);
        }
      })
    },
    initContents () {
      this.item.contents = [];
      _.forEach(this.cms_languages, l => {
        this.item.contents.push({ id: null, languageId: l.id, content: '' });
      })
    },
    initInventorySettings(inventory){
      return {
        id: null,
        inventoryId: inventory.id,
        name: inventory.name,
        agencyRate: null,
        commissionAccount: null,
        marginRate: null,
        purchaseAccount: null,
        purchaseUnitPrice: null,
        salesAccount: null,
        sellingUnitPrice: null,
        uvc: null,
        active: false,
        additionnalProductFee: null,
      };
    },
    initPortausCompanySettings(portausCompany) {
      const taxes = this.isEditionMode
        ? portausCompany.taxes
        : _.filter(portausCompany.taxes, tax => tax.indDefault === true);
      const cie =  {
        id: portausCompany.id,
        active: this.isEditionMode ? false : true,
        reservationActive: true,
        agencyRate: null,
        marginRate: null,
        purchaseUnitPrice: null,
        sellingUnitPrice: null,
        purchaseAccount: null,
        salesAccount: null,
        commissionAccount: null,
        taxable: true,
        taxes,
        variableRate: false,
        fixedRate: false,
        itemRate: null,
        additionnalProductFee: null,
        inventorySettings: portausCompany.inventorySettings,
        agencyRateByClasses: [],
        salesCommission: {
            fixedAmountInd: false,
            fixedRateInd: false,
            rate: null,
            fixedAmount: null,
            agencyRateByClasses : [],
          },
      }
      return cie;
    },
    open(){
      this.tabs = 'general';
      this.fullScreenLoading = true;
      Promise.all([
        this.getProduct(),
        this.fetchTaxes(),
        this.fetchTags(),
        this.fetchGLAccounts(),
        this.fetchLanguages(),
        this.fetchPortausCompany(),
        this.fetchInventories(),
        this.fetchMultiAgencyConfiguration(),
      ]).then(([product, taxes, tags, glAccount, languages, portausCompanies])=>{
        if(this.isEditionMode){
          this.providerOptions = [];
          Object.assign(this.item, product);

          this.actualSku = product.sku;
         

          if(this.item.provider!=null){
            let provider = {};
            provider.id = this.item.provider.id;
            provider.name = this.item.provider.name;
            provider.usualName = this.item.provider.usualName;
            this.providerOptions.push(provider);
          }

          
        }else{


          this.initContents();

          this.providerOptions= [];
          if(localStorage.PURCHASE_ORDER_MARGIN_VALUE!=null){
            this.item.marginRate = parseFloat(localStorage.PURCHASE_ORDER_MARGIN_VALUE);
          }
          
        }

        // initialisation des settings par compagnie
        _.forEach(portausCompanies, pc => {
            const portausCompanySettings = _.find(this.item.portausCompanySettings, pcs => pcs.id === pc.id);
            if (portausCompanySettings == null) {
              this.item.portausCompanySettings.push(this.initPortausCompanySettings(pc));
            } else {
              if (portausCompanySettings.reservationActive == null) {
                this.$set(portausCompanySettings, 'reservationActive', true);
              }
              if (portausCompanySettings.salesCommission == null) {
                portausCompanySettings.salesCommission = {
                  fixedAmountInd: false,
                  fixedRateInd: false,
                  rate: null,
                  fixedAmount: null,
                  agencyRateByClasses : [],
                }
              }
           
              if(_.size(_.get(portausCompanySettings, 'salesCommission.agencyRateByClasses')) > 0) {
                this.configureCommissionRateByCustomerInd= true;
              }

              if (_.size(portausCompanySettings.agencyRateByClasses) > 0) {
                  this.configureRateByCustomerInd = true;
                }
              if (_.get(portausCompanySettings, 'agencyRate') > 0) {
                this.$set(portausCompanySettings, 'variableRate', true);
                portausCompanySettings.itemRate = portausCompanySettings.agencyRate;
                
              } else if (_.get(portausCompanySettings, 'agencyFee') > 0){
                this.$set(portausCompanySettings, 'fixedRate', true);
               
              }
            }
            
          })

          if(!this.isEditionMode) {
            _.forEach(this.item.portausCompanySettings, pc => {
              pc.salesAccount =  _.head(_.filter(this.getGlAccountsByCompanyId[pc.id], gl => gl.number === '4200'));
            })
          }
         
         

        _.forEach(this.item.portausCompanySettings, pc => {
  
          //On vient initialiser les inventorySettings qui n'ont pas été renseigné.
            _.forEach(this.getInventoriesByPortausCompany[pc.id], inventory => {
              if (_.get(pc, 'inventorySettings') == null) {
                pc.inventorySettings = [];
              }
              const inventorySetting = _.find(pc.inventorySettings, invSetting => _.get(invSetting, 'inventoryId') === inventory.id);

              if (inventorySetting == null) {
                pc.inventorySettings.push(this.initInventorySettings(inventory));
              } else {
                inventorySetting.name = inventory.name;
                if (_.get(inventorySetting, 'agencyRate') > 0) {
                  this.$set(inventorySetting, 'variableRate', true);
                  inventorySetting.itemRate = inventorySetting.agencyRate;
                }
              }
            })
        })

        if(_.size(this.item.relatedProducts) > 0) {
          const relatedProducts = [];
          _.forEach(this.item.relatedProducts, r => {
            if (r.productId != null) {
              relatedProducts.push({
                id: r.id, product: { id: r.productId }, name: r.name, type :'PRODUCT',
              })
            } else {
              const tag = _.find(this.listTags, t => t.id === r.tagId);
              relatedProducts.push({
                id: r.id, tag: { id: r.tagId }, name: tag.code, type :'TAG',
              })
            }
          })
          this.item.relatedProducts = relatedProducts;
        }

        // if(this.item.agencyRate!=null && this.item.agencyRate>0){
        //   this.item.variableRate=true;
        //   this.item.itemRate = this.item.agencyRate
        // }

        // Si le tag actuel du produit n'est pas dans la liste alors on l'ajoute
        if(this.itemIdToEdit!=null){
          this.addCurrentTagIfNotPresent(this.listTags, product.tags);
        }
        this.fullScreenLoading = false;
      })

    },

    closeItemDialog(){
      this.$emit('close');
      this.$refs.itemForm.resetFields();
      this.item.externalId = null;
      this.actualSku= null;
      this.item.id = null;
      this.item.type = 1;
      this.item.active = true;
      this.item.variable_rate = false;
      this.item.commissionAccount = null;
      this.item.description = null;
      this.item.shortDescription = null;
      this.item.ean = null;
      this.item.provider = null;
      this.item.format = 1;
      this.item.height = null;
      this.item.isbn = null;
      this.item.length = null;
      this.item.marginRate= null;
      this.item.mpn = null;
      this.item.name = null;
      this.item.provider = null;
      this.item.purchaseAccount = null;
      this.item.purchaseUnitPrice = null;
      this.item.quantities = [];
      this.item.reorderLevel = null;
      this.item.returnable = null;
      this.item.salesAccount = null;
      this.item.sellingUnitPrice =null;
      this.item.sku = null;
      this.item.tags = [];
      this.item.taxable = true;
      this.item.taxes = [];
      this.item.unit =1;
      this.item.upc = null;
      this.item.uvc = '12';
      this.item.volume = '750';
      this.item.webLink = null;
      this.item.weight= null;
      this.item.width = null;
      this.item.agencyRate = null;
      this.item.itemRate = null;
  
      this.item.cmsName = null;
      this.item.cmsProvider = null;
      this.item.items = [];
      this.item.slug = null;
      this.item.contents = [];
      this.item.webSite = null;
      this.item.category = null;
      this.item.specificCategory = null;
      this.item.attributes = [];
      this.item.origins = [];
      this.item.items = [];
      this.item.image = null;
      this.item.published = true;
      this.item.publishedDate = dayjs().format('YYYY-MM-DD Z');
      this.configurationTabs = ['0'];
      this.configurationInventoryTabs = [];
      this.item.portausCompanySettings = [];
      this.item.agencyNumber = null;
      this.configureRateByCustomerInd = false;
      this.configureCommissionRateByCustomerInd = false
      this.item.panoramaCategory = null;
      this.item.panoramaSubCategory = null;
      this.item.panoramaSweetness = null;
      this.item.panoramaSugarLevel = null;
      this.item.panoramaAlcoholLevel = null;
      this.item.panoramaGrapes = null;
      this.item.panoramaClassification = null;
      this.item.panoramaAppellation = null;
      this.item.panoramaDesignation = null;
    },
    applyAutomaticRules () {
      
      _.forEach(this.item.portausCompanySettings, pc => {
        if(!pc.variableRate){
          pc.agencyRate=null;
        }else{
          pc.agencyRate=pc.itemRate;
        }
        if(!pc.fixedRate){
          pc.agencyFee=null;
        }

        _.forEach(pc.inventorySettings, inventorySetting => {
          if(!inventorySetting.variableRate){
            inventorySetting.agencyRate=null;
          }else{
            inventorySetting.agencyRate=inventorySetting.itemRate;
          }

          if (inventorySetting.unit === 2) {
            inventorySetting.uvc = 1;
          }
        })
      })

      if (this.item.unit === 2) {
        this.item.uvc = 1;
      }

      // if (!this.item.active) {
      //   this.item.published = false;
      // }

      if (this.item.cmsName == null || _.trim(this.item.cmsName) === '')  {
        this.item.cmsName = this.item.name;
      }

      if (this.item.slug == null || _.trim(this.item.slug) === '') {
        this.item.slug = _.kebabCase(this.item.cmsName);
      }

      if (this.item.specificCategory === "") {
        this.item.specificCategory = { id: null };
      }

      if (this.item.category === "") {
        this.item.category = { id: null };
      }
    },
    saveProduct(){
      return this.$refs['itemForm'].validate((valid)=>{
        if(valid){
          this.applyAutomaticRules();
          return this.createProduct(this.item)
            .then(productCreated=>{
              this.fullScreenLoading = false;
              this.closeItemDialog();
              this.$notify({
    						title: "Ajout d'un produit",
    						message: "Le produit a été ajouté avec succès!",
    						type: 'success'
    					});
            }).catch(err=>{
              console.log(err);
              this.fullScreenLoading = false;
              this.$notify({
          			title: "Ajout d'un produit",
          			message: "Oups... une erreur s'est produit lors de l'ajout du produit. Veuillez réessayer plus tard.",
          			type: 'error'
          		});
            })
        }
      })
    },
    editItem(){
      return this.$refs['itemForm'].validate()
        .then((valid) => {
          if(valid){
            this.fullScreenLoading = true;
            this.applyAutomaticRules();
            return this.updateProduct({ productToUpdate: this.item, extendedObjects: ['taxes', 'tags', 'contents', 'items', 'attributes', 'cmsProvider', 'origins'] })
              .then(()=>{
                this.fullScreenLoading = false;
                this.closeItemDialog();
                this.$notify({
      						title: "Modification d'un produit",
      						message: "Le produit a été modifié avec succès!",
      						type: 'success'
      					});
              }).catch(err=>{
                this.fullScreenLoading = false;
                if (err.response.status === 409) {
                  // erreur de slug
                  this.$message.error(`Le champs slug n'est pas unique. Veuillez spécifier une nouvelle valeur dans l'onglet CMS.`);
                } else {
                  this.$notify({
        						title: "Modification d'un produit",
        						message: "Oups... une erreur s'est produit lors de la modification du produit. Veuillez réessayer plus tard.",
        						type: 'error'
        					});
                }

              })
          }
        })
    },
    fetchPanoramaCategories(){
      return panoramaAPI.fetchCategories()
        .then(categories=>{
          this.panoramaCategories = categories;
        })
    },
    fetchPanoramaSubCategories(){
      return panoramaAPI.fetchSubCategories()
        .then(subCategories=>{
          this.panoramaSubCategories = subCategories;
        })
    },
    fetchPanoramaSweetness(){
      return panoramaAPI.fetchSweetness()
        .then(sweetness=>{
          this.panoramaSweetness = sweetness;
        })
    },
    ...mapActions('products',['createProduct', 'updateProduct', 'setExtendedObject']),
    ...mapActions('controlData',['fetchGLAccounts', 'fetchTaxes', 'fetchLanguages', 'fetchInventories', 'fetchPortausCompany', 'fetchMultiAgencyConfiguration', 'fetchCustomerClasses']),
	},
	computed: {
    panoramaSubCategoriesFiltered(){
      if(this.item.panoramaCategory!=null && this.item.panoramaCategory!=''){
        return _.filter(this.panoramaSubCategories, sc => sc.category.id === this.item.panoramaCategory.id);
      }else{
        return this.panoramaSubCategories;
      }
    },
    lang(){
      return this.$i18n.locale
    },
    productSpecificTypesChoices(){
      const productType = _.find(this.productTypes, p=> p.id === _.get(this.typeModel, 'id'));
      if (productType != null) {
        return productType.specifics
      }
      return [];
    },
    typeModel: {
      set(category){
        this.handleCmsUpdate({ category });
      },
      get(){ return this.item.category; }
    },
    specificTypeModel: {
      set(specificCategory){
        this.handleCmsUpdate({ specificCategory });
      },
      get(){ return this.item.specificCategory; }
    },
    isEditionMode () {
      return this.itemIdToEdit != null;
    },
    canEditProductInfos(){
      return this.$can('write', 'ConfigProducts');
    },
    canEditProductCMSInfos(){
      return this.$can('write', 'CMS');
    },
    canReadProductCMSInfos(){
      return this.$can('read', 'CMS');
    },
    cmsName () {
      if (_.get(this.item, 'cmsName') == null) {
        return _.get(this.item, 'name');
      }
      return _.get(this.item, 'cmsName');
    },
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    REPRESENTATIVE_MODULE_ENABLED(){
      if(localStorage.REPRESENTATIVE_MODULE!=null){
        return JSON.parse(localStorage.REPRESENTATIVE_MODULE).active;
      }else{
        return false;
      }
    },
    ...mapState('controlData',['gl_accounts','taxes', 'languages', 'portausCompanies', 'customerClasses']),
    ...mapGetters('controlData',['gl_account_name', 'isCMSModuleActivated', 'getGlAccountsByCompanyId', 'getGlSalesAccountsByCompanyId','getInventoriesByPortausCompany', 'isMultiAgencyModuleActivated', 'getCustomerClassById']),
    ...mapState('inventory',['inventories']),
    ...mapGetters('inventory', ['isMultipleInventorySystem']),
    ...mapGetters(['hasAccessToCompany']),
	},
  mounted () {
    this.panoramaCategories = [];
    this.panoramaSubCategories = [];
    this.panoramaSweetness = [];
    this.fetchProductTypes();
    this.fetchInventories();
    this.fetchCustomerClasses();
    this.fetchPanoramaCategories();
    this.fetchPanoramaSubCategories();
    this.fetchPanoramaSweetness();
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;

}

.el-form-item{
  margin-bottom:20px;
}



  .dialog-footer{
    position: fixed;
    display: block;
    bottom: 0px;
    width: 100%;
    background-color: #f3f7fa;
    height:50px;
    margin-left:-20px;
    padding-top:10px;
    border-top:1px solid #E4E7ED;
    z-index:100;
  }


</style>
